import { CENTRAL_APP_URL } from "../../../lib/hosting-contract";

export function demoStaffHref() {
  return CENTRAL_APP_URL;
}

export function demoCaseHref(caseId: string) {
  return `${CENTRAL_APP_URL}workspace/case-overview?caseId=${encodeURIComponent(caseId)}`;
}

export function demoWorkspaceHref(screenId: string) {
  return `${CENTRAL_APP_URL}workspace/${encodeURIComponent(screenId)}`;
}
